import { jsx as i, jsxs as l } from "react/jsx-runtime";
import { Text as g, Box as a, Flex as m, Icon as d, Spinner as C } from "@chakra-ui/react";
import { useContext as s } from "react";
import { CheckIcon as w } from "./check-icon.js";
import { StepContext as p } from "./step-context.js";
import { TimesIcon as z } from "./times-icon.js";
import { ThemeColorVariable as T, ThemeFontSizeVariable as v, ThemeFontVariable as V, ThemeSpaceVariable as x, ThemeRadiusVariable as h } from "../../theme/theme-types.js";
const S = (e, r) => {
  switch (!0) {
    case e:
      return "32px";
    case !!r:
      return "24px";
    default:
      return "13px";
  }
};
function I(e, r) {
  if (!r) return "0px";
  switch (e) {
    case "32px":
      return "4px";
    case "13px":
      return "-6px";
    case "24px":
    default:
      return "0px";
  }
}
function f() {
  const { isActiveStep: e, iconColor: r, color: n, icon: t } = s(p), o = S(e, t), c = e ? "20px" : "16px";
  return /* @__PURE__ */ l(
    a,
    {
      backgroundColor: n,
      borderRadius: "full",
      w: o,
      minW: o,
      h: o,
      minH: o,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      color: r,
      children: [
        t === "check" && /* @__PURE__ */ i(d, { as: w, boxSize: c }),
        t === "spinner" && /* @__PURE__ */ i(C, { size: e ? "sm" : "xs" }),
        t === "times" && /* @__PURE__ */ i(d, { as: z, boxSize: c })
      ]
    }
  );
}
function H() {
  const { showDivider: e, dividerColor: r } = s(p);
  return /* @__PURE__ */ l(m, { direction: "column", alignItems: "center", w: "48px", gap: x.Small, children: [
    /* @__PURE__ */ i(f, {}),
    e && /* @__PURE__ */ i(a, { width: "3px", minH: "46px", bg: r, borderRadius: h.Small })
  ] });
}
function k() {
  const { showDivider: e, dividerColor: r } = s(p);
  return /* @__PURE__ */ l(m, { direction: "row", alignItems: "center", h: "48px", gap: x.Small, children: [
    /* @__PURE__ */ i(f, {}),
    e && /* @__PURE__ */ i(a, { w: "100%", h: "3px", bg: r, borderRadius: h.Small })
  ] });
}
function D() {
  const { isActiveStep: e, orientation: r, label: n, icon: t } = s(p), o = r === "vertical", c = S(e, t), u = I(c, o), b = typeof n == "string" ? /* @__PURE__ */ i(
    g,
    {
      mt: u,
      fontFamily: V.SubHeader,
      fontSize: v.Medium,
      color: T.OnBackgroundHeader,
      fontWeight: "medium",
      children: n
    }
  ) : /* @__PURE__ */ i(a, { mt: u, children: n });
  return /* @__PURE__ */ l(m, { w: "100%", h: "100%", direction: o ? "row" : "column", children: [
    o ? /* @__PURE__ */ i(H, {}) : /* @__PURE__ */ i(k, {}),
    b
  ] });
}
export {
  D as Step
};
